import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div class=\"bv-inline\" {{css-vars this.style}} ...attributes>\n  {{yield}}\n</div>")